



























































import { Component, Watch } from 'vue-property-decorator';
import FormFooter from '@/components/FormFooter.vue';
import TagSelect from '@/components/TagSelect.vue';
import FormBase from '@/mixins/FormBase';
import { Action, Getter } from 'vuex-class';
import UserGroup from '@/core/interfaces/UserGroup';
import VehicleType from '@/core/interfaces/VehicleType';
import Role from '@/core/interfaces/Role';
import FarmGroup from '@/core/interfaces/FarmGroup';
import User from '@/core/interfaces/User';

@Component({
    components: { FormFooter, TagSelect },
})
export default class UserGroupForm extends FormBase<UserGroup> {
    @Action('saveUserGroup')
    saveAction!: (userGroup: Partial<UserGroup>) => Promise<UserGroup>;

    @Getter('roles')
    roles!: Role[];

    @Getter('vehicleTypes')
    vehicleTypes!: VehicleType[];

    @Getter('farmGroups')
    farmGroups!: FarmGroup;

    @Getter('users')
    users!: User[];

    name = '';

    farmGroupIds: number[] = [];

    vehicleTypeIds: number[] = [];

    roleIds: number[] = [];

    userIds: number[] = [];

    @Watch('initial', { immediate: true })
    async setFromInitial(): Promise<void> {
        if (!this.initial) {
            return;
        }

        this.name = this.initial.name || '';

        this.roleIds = [...(this.initial.role_ids || [])];
        this.vehicleTypeIds = [...(this.initial.vehicle_types_ids || [])];
        this.farmGroupIds = [...(this.initial.farm_group_ids || [])];
        this.userIds = [...(this.initial.user_ids || [])];
    }

    get parseForm(): Partial<UserGroup> {
        return {
            ...this.initial,
            id: this.initial?.id || undefined,
            name: this.name,
            role_ids: this.roleIds,
            vehicle_types_ids: this.vehicleTypeIds,
            farm_group_ids: this.farmGroupIds,
            user_ids: this.userIds,
        };
    }
}
